export default function selector(storeState) {
    const appsReport = _.get(storeState, 'appsReport');

    return {
        profile: storeState.profile,
        ...appsReport,
    };
}
